{
    "coordinates": [
        38.55266999551583,
        -108.40353117984913
    ],
    "tooltip": "Morrison",
    "title": "Morrison Formation",
    "country": "United States",
    "period": "Jurassic",
    "alt": "TODO"
}
